<template>
	<el-dialog width="420px" class="dialog" :title="title" :visible="visible" @close="closeFun">
		<el-form
			ref="ruleForm"
			label-position="left"
			:rules="rules"
			:model="dialogForm"
			label-width="120px"
		>
			<el-form-item label="手机号：" prop="phone">
				<el-input
					style="width:100%"
					v-model="dialogForm.phone"
					:maxlength="11"
					placeholder="请输入"
				></el-input>
			</el-form-item>
			<el-form-item label="推荐人" prop="referral">
				<el-input
					style="width:100%"
					v-model="dialogForm.referral"
					:maxlength="200"
					placeholder="请输入"
				></el-input>
			</el-form-item>
			<el-form-item label="推荐类型：" prop="referralType">
				<el-select
					v-model="dialogForm.referralType"
					placeholder="请选择"
					clearable
					style="width: 100%"
				>
					<el-option
						v-for="item in referralTypeList"
						:key="item.referralTypeId"
            :label="item.referralTypeName"
            :value="item.referralTypeId"
						style="width: 100%"
					>
					</el-option>
				</el-select>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="closeFun">取 消</el-button>
			<el-button type="primary" :loading="btnLoading" @click="addFun">确 定</el-button>
		</div>
	</el-dialog>
</template>
<script>
export default {
	data() {
		return {
			title: '创建',
			operaType: 'add',
			visible: false,
			referralTypeList: [
				{
					referralTypeId: 1,
					referralTypeName: '门店导购',
				},
				{
					referralTypeId: 2,
					referralTypeName: '小区物业',
				},
				{
					referralTypeId: 3,
					referralTypeName: '普通用户',
				},
			],
			dialogForm: {
				phone: '',
				referral: '',
				referralType: '',
			},
			rules: {
				phone: [
					{ required: true, message: '请输入手机号', trigger: 'blur' },
					{ pattern: /^1[3-9]\d{9}/, message: '请输入正确手机号', trigger: 'change' },
				],
				referral: [{ required: true, message: '请输入推荐人', trigger: 'blur' }],
				referralType: [{ required: true, message: '请选择', trigger: 'change' }],
			},
			btnLoading: false,
		}
	},
	methods: {
		// 打开弹框
		async opendDialog (operaType = 'add', initData) {
			this.operaType = operaType
			this.title = operaType === 'add' ? '创建' : '编辑'
			this.resetFormFun()
			this.visible = true
			if (operaType === 'edit') {
				for (const key in initData) {
					this.dialogForm[key] = initData[key]
				}
				this.editId = initData.id
			} else {
				this.editId = ''
				this.dialogForm = {
					phone: '',
					referral: '',
					referralType: '',
				}
			}
		},
		// 关闭弹框
		closeFun() {
			this.visible = false
		},
		// 表单重置
		resetFormFun () {
			if (this.$refs.ruleForm) {
				this.$refs.ruleForm.resetFields()
			}
		},
		addFun() {
			this.$refs.ruleForm.validate(valid => {
				if (valid) {
					// console.log('====dialogForm', this.dialogForm)
					this.addDataReqFun()
				}
			})
		},
		// 新增或者编辑请求
		addDataReqFun () {		
			const params = {
				...this.dialogForm,
				id: this.operaType === 'add'? undefined : this.editId
			}
			const url = `/autoapp-default-server-recovery/api/commission/referral/save`
			this.btnLoading = true
			this.HttpService.post(url, params).then(res => {
				this.btnLoading = false
				if (res.statusCode === 200) {
					const msg = this.operaType === 'add' ? '创建成功' : '编辑成功'
					this.$message.success(msg)
					this.$emit('opera-success')
					this.closeFun()
				} else {
					const msgTip = res.message || '请求失败'
					this.$message.error(msgTip)
				}
			}, err => {
				this.btnLoading = false
			})
		}
	},
}
</script>
<style lang="scss">
.dialog {
	.dialog-footer {
		padding: 20px 60px;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/commissionManage/recommendPersonnelManage/components/AddPersonal.vue